/**
 * Outermost shell — wraps both the login screen and the authenticated area.
 *
 * Two jobs: the global "backend unreachable" banner (per §11.2, shown when the health probe
 * `GET /api/auth/me` fails for a reason other than `401`), and the toast layer — mounted here
 * because toasts are portaled to `document.body` and outlive the screen that raised them.
 * Everything else renders through the outlet.
 */

import { Outlet } from 'react-router';
import { describeError } from '../api/client';
import { Spinner, ToastProvider } from '../components';
import { useAuth } from './useAuth';

export function RootLayout() {
  const { query, isBackendUnreachable } = useAuth();

  return (
    <ToastProvider>
      <div className="app-shell">
        {isBackendUnreachable ? (
          <div className="banner banner--error" role="alert">
            <span className="banner__text">
              <strong>Backend unreachable.</strong> {describeError(query.error)} Anything on screen
              may be stale.
            </span>
            <button
              type="button"
              className="table-action"
              onClick={() => void query.refetch()}
              disabled={query.isFetching}
            >
              {query.isFetching ? <Spinner size="sm" /> : null}
              <span className="table-action__label">Retry</span>
            </button>
          </div>
        ) : null}
        <Outlet />
      </div>
    </ToastProvider>
  );
}

export default RootLayout;
